import type { SkeletonProps } from "@chakra-ui/react"
import { Skeleton, Td, Tr } from "@chakra-ui/react"

interface TableSkeletonProps extends SkeletonProps {
    rowsCount?: number, rowHeight?: any, colSpan?: number
}

export const TableSkeleton = ({ rowsCount = 10, colSpan = 1, isLoaded = false, children, rowHeight, height = '20px', ...rest }: TableSkeletonProps) => {
    if (isLoaded)
        return children

    return Array.from(Array(rowsCount).keys()).map((id) => (<Tr key={id} height={rowHeight}><Td colSpan={colSpan}><Skeleton {...rest} height={height} /></Td></Tr>))
}